import React, { useState, useEffect } from 'react';
import { ref, onValue } from 'firebase/database';
import { database } from '../firebase';
import './ServiceDetailPage.css';

const ServiceDetailPage = ({ categoryId, subCategoryId, itemId, onBack }) => {
  const [service, setService] = useState(null);
  const [categoryTitle, setCategoryTitle] = useState('');
  const [loading, setLoading] = useState(true);
  const whatsappNumber = '905343437123';

  useEffect(() => {
    if (!categoryId || !itemId) {
      setLoading(false);
      return;
    }
    const isLegacy = !subCategoryId || subCategoryId === 'genel';
    const itemPath = isLegacy
      ? `productCategories/${categoryId}/items/${itemId}`
      : `productCategories/${categoryId}/subCategories/${subCategoryId}/items/${itemId}`;
    const catPath = `productCategories/${categoryId}/title`;

    const itemRef = ref(database, itemPath);
    const catRef = ref(database, catPath);

    const unsubItem = onValue(itemRef, (snapshot) => {
      const data = snapshot.val();
      setService(data ? { id: itemId, ...data } : null);
    });
    const unsubCat = onValue(catRef, (snapshot) => {
      setCategoryTitle(snapshot.val() || '');
    });

    setLoading(false);
    return () => {
      unsubItem();
      unsubCat();
    };
  }, [categoryId, subCategoryId, itemId]);

  const handleWhatsApp = () => {
    const message = service
      ? `Merhaba, ${service.title} hakkında bilgi almak istiyorum.`
      : 'Merhaba, hizmet hakkında bilgi almak istiyorum.';
    window.open(`https://wa.me/${whatsappNumber}?text=${encodeURIComponent(message)}`, '_blank');
  };

  if (loading) {
    return (
      <div className="service-detail-page">
        <div className="container">
          <p className="service-detail-loading">Yükleniyor...</p>
        </div>
      </div>
    );
  }

  if (!service) {
    return (
      <div className="service-detail-page">
        <div className="container">
          <p className="service-detail-empty">Hizmet bulunamadı.</p>
          {onBack && (
            <button type="button" onClick={onBack} className="service-detail-back-btn">
              ← Hizmetlere dön
            </button>
          )}
        </div>
      </div>
    );
  }

  const body = service.content || service.description || '';

  return (
    <div className="service-detail-page">
      <article className="service-detail-article">
        <div className="container">
          {onBack && (
            <button type="button" onClick={onBack} className="service-detail-back-btn">
              ← Hizmetlere dön
            </button>
          )}
          <header className="service-detail-header">
            {categoryTitle && (
              <p className="service-detail-category">{categoryTitle}</p>
            )}
            <h1 className="service-detail-title">{service.title}</h1>
            {service.description && !service.content && (
              <p className="service-detail-lead">{service.description}</p>
            )}
          </header>
          {body && (
            <div className="service-detail-body">
              <div className="service-detail-content" style={{ whiteSpace: 'pre-wrap' }}>{body}</div>
            </div>
          )}
          <div className="service-detail-actions">
            <button type="button" onClick={handleWhatsApp} className="service-detail-cta">
              Teklif Al / Bilgi Al
            </button>
          </div>
        </div>
      </article>
    </div>
  );
};

export default ServiceDetailPage;
